import { render, staticRenderFns } from "./OffersTable.vue?vue&type=template&id=296e4ba7"
import script from "./OffersTable.vue?vue&type=script&lang=js"
export * from "./OffersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports